<template>
  <svg viewBox="0 0 24 12" xmlns="http://www.w3.org/2000/svg">
    <title>Arrow icon</title>
    <path d="M18.015 4.5H0L0 7.5H18.015V12L24 6L18.015 0V4.5Z"/>
  </svg>
</template>

<script>
export default {
  name: 'KIconArrow'
}
</script>
